// webclient/src/services/org-config/org-config-api.ts
import { ApiInstance } from '@src/services/api-instance';
import { OrgConfigV1Service } from './modules/v1/org-config-api-v1';

export class OrgConfigApi {
  private client: ApiInstance;
  public v1: OrgConfigV1Service;

  constructor(client?: ApiInstance) {
    const base = '/api-org-config';
    this.client = client || new ApiInstance(base, 30000);
    this.v1 = new OrgConfigV1Service(this.client);
  }
}
